import PlayCircleImg from '../../../../images/icons/desktop.svg'
import AppImg from '../../../../images/icons/app.svg'
import DirectoryImg from '../../../../images/icons/directory.svg'
import { myPgaIOSUrl, myPgaAndroidUrl } from '../../../../constants'

const process = [
  {
    number: '1',
    image: PlayCircleImg,
    title: 'Get Certified',
    text:
      'PGA.Coach training is interactive video training designed to give a deeper understanding of the Seven Stages of ADM and how to incorporate them into a facility plan. The training takes two hours to complete.',
    buttons: [
      {
        text: 'Get Started',
        url: 'https://pgacoach.lightspeedvt.com/'
      }
    ],
    icon:
      'M1.5 47.6673h24.0967v40.9643H1.5V47.6673zm11.9815.0002V22.5512h50.2992v66.0807H22.0749m16.556-65.6176V1.5H139.5v70.4491H63.7807m75.719-16.3577H63.7806m16.3113 16.3577h17.6096l2.4095 10.4733 7.6922 6.2095H71.5656M80.53 71.949l-2.41 10.4733-7.6923 6.2095h36.2376M89.198 43.01c8.2153 0 14.875-6.6598 14.875-14.875 0-8.2153-6.6597-14.875-14.875-14.875-8.2152 0-14.875 6.6597-14.875 14.875 0 8.2152 6.6598 14.875 14.875 14.875zm-3.7846-21.293v13.5313l11.4922-6.766-11.4922-6.7653z',
    width: '141',
    height: '91',
    strokeWidth: '2'
  },
  {
    number: '2',
    image: DirectoryImg,
    title: 'Get Your Profile',
    text:
      'PGA Coach Profiles is a new product designed to help you market yourself to the millions of people that visit PGA.com monthly. Leverage the PGA brand to find new customer leads for your coaching business and so much more.',
    buttons: [
      {
        text: 'Create Your Profile',
        url: 'https://www.pga.com/account/coach-profile'
      }
    ],
    icon:
      'M8.3036 19.5h16.388m-16.388-5h16.388M8.3037 9h16.388m36.612 15.5h16.388m-16.388-5h16.388M61.3037 14h16.388m-16.388 32.5h16.388m-16.388-5h16.388M61.3037 36h16.388m-16.388 32.5h16.388m-16.388-5h16.388M61.3037 58h16.388M1 1h87v79H1V1zm39 6h17v19H40V7zm0 23h17v19H40V30zm0 23h17v19H40V53z',
    width: '89',
    height: '81',
    strokeWidth: '2'
  },
  {
    number: '3',
    image: AppImg,
    title: 'Get the App',
    text:
      'Through the PGA Coach App, PGA and LPGA Members can get access to activity planning, notetaking and assessment tools that make it easy to quickly start applying ADM principles.',
    buttons: [
      {
        image: 'AppleStore',
        text: 'Apple Store',
        url: myPgaIOSUrl
      },
      {
        image: 'GooglePlay',
        text: 'Google Play',
        url: myPgaAndroidUrl
      }
    ],
    icon:
      'M10 2h43c4.4183 0 8 3.5817 8 8v73c0 4.4183-3.5817 8-8 8H10c-4.4183 0-8-3.5817-8-8V10c0-4.4183 3.5817-8 8-8zm22.394 80.1c1.9748 0 3.5757-1.771 3.5757-3.9556 0-2.1845-1.601-3.9555-3.5758-3.9555s-3.5757 1.771-3.5757 3.9555c0 2.1846 1.6009 3.9556 3.5757 3.9556zM3.8995 17.8222h54.3068H3.8996zm0 49.4445h54.3068H3.8996z',
    width: '63',
    height: '93',
    strokeWidth: '4'
  }
]

export default process
